import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="selectpicker"
//
// Keeps a bootstrap-select (.selectpicker) <select> in sync when an <option> is
// streamed into it by a Turbo Stream — e.g. a new filter choice appended after a
// record is created elsewhere. bootstrap-select renders its own UI from the
// underlying <select>, so a bare Turbo append stays invisible until refreshed.
//
// Initial initialization stays with turbotable#rendered; this controller only
// refreshes, so the two don't fight over the same element.
export default class extends Controller {
  static targets = ["option"];

  optionTargetConnected() {
    if (typeof $.fn.selectpicker !== "function") return;
    const $select = $(this.element);
    // Skip until bootstrap-select has initialized the element; the initial
    // init (turbotable#rendered) will pick up any options present by then.
    if (!$select.data("selectpicker")) return;
    $select.selectpicker("refresh");
  }
}
